"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageGallery = void 0;
exports.hasGallery = hasGallery;
var flickity_1 = __importDefault(require("flickity"));
require("flickity-fullscreen");
var config_1 = require("../config");
var ImageGallery = /*#__PURE__*/_createClass(function ImageGallery() {
  _classCallCheck(this, ImageGallery);
  this.imageGallerys = [];
  var imageGallerys = document.querySelectorAll(config_1.CONFIG.imageGallery.main);
  this.imageGallerys = Array.from(imageGallerys).map(function (imageGallery) {
    var gallery = new flickity_1["default"](imageGallery, config_1.CONFIG.imageGallery.options);
    var element = gallery.element;
    if (element.dataset.mode === 'fullscreen') {
      gallery.on('staticClick', function () {
        gallery.toggleFullscreen();
        element.classList.add('is-fullscreen');
      });
    }
    if (gallery.slides.length === 1) {
      gallery.options.pageDots = false;
      gallery.pageDots.holder.style.display = 'none';
      gallery.nextButton.element.style.display = 'none';
      gallery.prevButton.element.style.display = 'none';
    }
    setTimeout(function () {
      gallery.resize();
    }, 500);
    return gallery;
  });
});
exports.ImageGallery = ImageGallery;
function hasGallery() {
  if (document.querySelectorAll(config_1.CONFIG.imageGallery.main).length > 0) {
    return true;
  }
  return false;
}